import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import {
	Box,
	Dialog,
	DialogContent,
	DialogTitle,
	Divider,
	IconButton,
	Link,
	Stack,
	Tooltip,
	Typography,
} from "@mui/material";
import React, { useState } from "react";

type ContactDialogProps = {
	open: boolean;
	onClose: () => void;
};

const EMAIL = "Polarshowrevyen@gmail.com";

const ContactDialog: React.FC<ContactDialogProps> = ({ open, onClose }) => {
	const [copied, setCopied] = useState(false);

	const handleCopyEmail = async () => {
		try {
			await navigator.clipboard.writeText(EMAIL);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch (err) {
			console.error("Failed to copy email:", err);
		}
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle>
				<Stack
					direction="row"
					justifyContent="space-between"
					alignItems="center"
				>
					<Typography variant="h6">Kontakt oss</Typography>
					<IconButton onClick={onClose} size="small">
						<CloseIcon />
					</IconButton>
				</Stack>
			</DialogTitle>
			<DialogContent>
				<Stack spacing={3}>
					{/* Email */}
					<Box>
						<Typography variant="subtitle2" color="text.secondary">
							E-post
						</Typography>
						<Stack direction="row" alignItems="center" spacing={1}>
							<Typography
								variant="body1"
								sx={{ userSelect: "text" }}
							>
								{EMAIL}
							</Typography>
							<Tooltip title={copied ? "Kopiert!" : "Kopier"}>
								<IconButton
									size="small"
									onClick={handleCopyEmail}
								>
									{copied ? (
										<CheckIcon
											fontSize="small"
											color="success"
										/>
									) : (
										<ContentCopyIcon fontSize="small" />
									)}
								</IconButton>
							</Tooltip>
						</Stack>
					</Box>

					<Divider />

					{/* Styreleder */}
					<Box>
						<Typography variant="subtitle2" color="text.secondary">
							Styreleder
						</Typography>
						<Typography variant="body1">
							Inger Lise Ebeltoft
						</Typography>
						<Link
							href="tel:+4795144879"
							underline="hover"
							color="inherit"
						>
							Tlf: 951 44 879
						</Link>
					</Box>

					{/* Nestleder */}
					<Box>
						<Typography variant="subtitle2" color="text.secondary">
							Nestleder
						</Typography>
						<Typography variant="body1">Kari Biti</Typography>
						<Link
							href="tel:+4794865438"
							underline="hover"
							color="inherit"
						>
							Tlf: 948 65 438
						</Link>
					</Box>
				</Stack>
			</DialogContent>
		</Dialog>
	);
};

export default ContactDialog;
